import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PtfButton from "@/components/PtfButton";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" description="The page you are looking for does not exist." />
      <section className="min-h-[70vh] grid place-items-center bg-ptf-bg px-6 pt-32 pb-20">
        <div className="text-center max-w-lg">
          <p className="text-[0.7rem] uppercase tracking-[0.28em] text-ptf-secondary mb-5">404</p>
          <h1 className="font-display font-extrabold uppercase text-5xl md:text-6xl tracking-tight text-ptf-primary leading-[0.95]">
            This trail doesn't exist.
          </h1>
          <p className="mt-6 text-ptf-text/70 leading-relaxed">
            The page you are looking for has moved or was never here. Try the
            <Link to="/programmes" className="underline underline-offset-4 mx-1 hover:text-ptf-primary">Programmes</Link>
            page, or head back to the start.
          </p>
          <div className="mt-8 flex justify-center">
            <PtfButton to="/">Back to Home</PtfButton>
          </div>
        </div>
      </section>
    </>
  );
}
